import { Link } from "@tanstack/react-router";
import { Logo } from "./Logo";
import { useLanguage } from "@/i18n/LanguageProvider";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Facebook, Instagram, Youtube, Twitter } from "lucide-react";

export function Footer() {
  const { t } = useLanguage();

  return (
    <footer className="mt-24 bg-muted/40 border-t border-border/60">
      <div className="container mx-auto px-4 py-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
        <div className="space-y-4">
          <Logo />
          <p className="text-sm text-muted-foreground max-w-xs">{t.footer.tag}</p>
          <div className="flex gap-2">
            {[Facebook, Instagram, Youtube, Twitter].map((Icon, i) => (
              <a
                key={i}
                href="#"
                aria-label="social"
                className="h-9 w-9 rounded-full bg-background border border-border flex items-center justify-center hover:bg-primary hover:text-primary-foreground transition"
              >
                <Icon className="h-4 w-4" />
              </a>
            ))}
          </div>
        </div>

        <div>
          <h4 className="font-bold mb-3">{t.footer.explore}</h4>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li>
              <Link to="/courses" className="hover:text-primary">
                {t.nav.courses}
              </Link>
            </li>
            <li>
              <Link to="/learning-path" className="hover:text-primary">
                {t.nav.path}
              </Link>
            </li>
            <li>
              <Link to="/blog" className="hover:text-primary">
                {t.nav.blog}
              </Link>
            </li>
            <li>
              <Link to="/events" className="hover:text-primary">
                {t.nav.events}
              </Link>
            </li>
            <li>
              <Link to="/faq" className="hover:text-primary">
                {t.nav.faq}
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-bold mb-3">{t.footer.legal}</h4>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li>
              <Link to="/legal/$slug" params={{ slug: "privacy" }} className="hover:text-primary">
                {t.footer.privacy}
              </Link>
            </li>
            <li>
              <Link to="/legal/$slug" params={{ slug: "terms" }} className="hover:text-primary">
                {t.footer.terms}
              </Link>
            </li>
            <li>
              <Link
                to="/legal/$slug"
                params={{ slug: "child-safety" }}
                className="hover:text-primary"
              >
                {t.footer.safety}
              </Link>
            </li>
            <li>
              <Link to="/legal/$slug" params={{ slug: "cookies" }} className="hover:text-primary">
                {t.footer.cookies}
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-bold mb-3">{t.footer.newsletter}</h4>
          <form className="flex gap-2" onSubmit={(e) => e.preventDefault()}>
            <Input type="email" placeholder="email@example.com" className="rounded-full" />
            <Button
              type="submit"
              className="rounded-full bg-gradient-primary text-primary-foreground border-0"
            >
              {t.footer.subscribe}
            </Button>
          </form>
        </div>
      </div>
      <div className="border-t border-border/60 py-5 text-center text-xs text-muted-foreground">
        © {new Date().getFullYear()} {t.brand}. {t.footer.rights}
      </div>
    </footer>
  );
}
